import { ApiClient } from "./api-client";

export function getUsers(queryParams, systemAccount = false) {
  queryParams?.append('systemAccount', (systemAccount ? 'true' : 'false'));
  return ApiClient.getInstance().get('/user', {
    params: queryParams
  }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function getUser(userId, queryParams) {
  return ApiClient.getInstance().get('/user/:id', { urlParams: { id: userId }, params: queryParams }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function updateUser(userId, firstname, lastname, email, company, role, companyManager, credits) {
  return ApiClient.getInstance().put('/user',  { id: userId, firstname: firstname, lastname: lastname, email: email, companyId: company, roleId: role, companyManager: companyManager, credits: credits }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function updateUserImage(userId, imageFile) {
  return ApiClient.getInstance().put('/user/image', imageFile, { headers: { 'Content-Type': imageFile.type || 'image/png', } }).catch((error) => {
    console.error('Error updating user image:', error);
    throw error;
  });
}

export function updateUserName(userId, email, firstname, lastname) {
  return ApiClient.getInstance().put('/user', { id: userId, email: email, firstname: firstname, lastname: lastname }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function updateUserEmail(userId, email) {
  return ApiClient.getInstance().put('/user', { id: userId, email: email }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function regenerateUserPersonalCode(userId){
  return ApiClient.getInstance().put('/user/personalcode', { id: userId }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  }).then((res)=>res.data);
}

export function deleteUser(userId) {
  return ApiClient.getInstance().delete('/user/:id', { urlParams: { id: userId } }).catch((error) => {
    console.error('Error deleting user:', error);
    throw error;
  });
}

export async function importUsers(file) {
  return ApiClient.getInstance().post('/user/import', file, { headers: { 'Content-Type': 'text/csv', } }).catch((error) => {
    console.error('Error updating user image:', error);
    throw error;
  });
}
